import { render } from "./DailyStudentReport.vue?vue&type=template&id=edbf24f4&scoped=true"
import script from "./DailyStudentReport.vue?vue&type=script&lang=js"
export * from "./DailyStudentReport.vue?vue&type=script&lang=js"

import "./DailyStudentReport.vue?vue&type=style&index=0&id=edbf24f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbf24f4"]])

export default __exports__